import React from 'react';

export default props => (
	<svg
		{...props}
		width="20px"
		height="18px"
		viewBox="0 0 20 18">
		<g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
			<g transform="translate(1.562500, 1.125000)" stroke="currentColor" strokeWidth="1.5">
				<path d="M4.08562073e-14,7.87500003 L16.8750001,7.87500003" />
				<polyline id="Path" points="9.00000004 15.7500001 16.8750001 7.87500003 9.00000004 -2.04281037e-13" />
			</g>
		</g>
	</svg>
);